module.exports = __webpack_public_path__ + "img/continue.3ff04202.png";